/** @file QUAD_PALETTE: the twelve quad colours of the quads view, one per drawable by `quadColorOf`. */

/** Hex colours spread around the hue circle, bright enough to read at 25 % over the dark viewport. */
export const QUAD_PALETTE: readonly string[] = [
  '#ff6b6b', '#ffa94d', '#ffd43b', '#a9e34b', '#51cf66', '#20c997',
  '#22b8cf', '#4dabf7', '#748ffc', '#9775fa', '#da77f2', '#f783ac',
];
